<div class="col-md-12" *ngrxLet="sharedFacade.isClearSearch$ as isClearSearch">
  <piqet-angular-portlet
    [columnDefs]="columnDefsForProductPackage"
    [frameworkComponents]="frameworkComponents"
    [gridData]="productProjects"
    [pageNo]="$any(productProjects)?.draw"
    (openBtnModal)="addNewProductProject(0, 'Make a product')"
    [class]="'fixedHeight'"
    [gridName]="gridNameProductProject"
    [headerBtn]="'Add new product project'"
    [createAccess]="createAccess"
    [isClearSearch]="isClearSearch"
  ></piqet-angular-portlet>
</div>
